import { render } from "./ScenarioReport.vue?vue&type=template&id=18385fd2&scoped=true"
import script from "./ScenarioReport.vue?vue&type=script&lang=ts"
export * from "./ScenarioReport.vue?vue&type=script&lang=ts"

import "./ScenarioReport.vue?vue&type=style&index=0&id=18385fd2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-18385fd2"

export default script
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTr,QTh,QTd,QChip,QBtn,QBtnGroup,QSelect,QLinearProgress,QField});
